export default __webpack_public_path__ + "static/media/2.a6b33f44.png";